function readCookie(name: string): string | null {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split("=")[1]) : null;
}

export function getPartnerDiscountCode(): string | null {
  return readCookie("zerply_discount");
}

export function getSignupPartner(): string | null {
  return readCookie("zerply_partner");
}
